export default __webpack_public_path__ + "static/media/jingle.d960d62f.mp3";